import { Component, input } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { NgClass } from '@angular/common';
import { BasicCardTitleComponent } from './basic-card-title/basic-card-title.component';

@Component({
  selector: 'mwe-basic-card',
  templateUrl: './basic-card.component.html',
  imports: [NgClass, BasicCardTitleComponent],
})
export class BasicCardComponent {
  iconClass = input<string>();
  cardClass = input<string>();
  cardTitle = input<string>();
  cardTitleParams = input();
  hasBackground = input<boolean>(false);
  height100 = input<boolean>(false);
  optionalLastChildClass = input<string>();
  noBoxShadow = input<boolean>(false);
  headingNodeType = input<TextNodeType>('h5');
}
